import { Navbar } from '../components/Navbar';
import { SiteFooter } from '../components/SiteFooter';
import { PricingPlans } from '../components/PricingPlans';
import { PricingComparison } from '../components/PricingComparison';
import { useSeo } from '../lib/seo';

export function Pricing() {
  useSeo({
    title: 'Precios y planes · Zettapost · Sin permanencia, prueba 3 días gratis',
    description:
      'Planes Zettapost para freelancers, marcas y agencias. Cambia o cancela cuando quieras, sin permanencia. Empieza con 3 días gratis.',
    canonical: 'https://zettapost.com/precios',
  });

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <main className="max-w-5xl mx-auto px-6 py-14">
        <div className="text-center max-w-xl mx-auto mb-10">
          <p className="text-xs uppercase tracking-widest text-brand-600 font-semibold mb-2">Precios</p>
          <h1 className="text-3xl font-extrabold text-slate-900">
            Elige el plan perfecto para ti
          </h1>
          <p className="mt-3 text-slate-500">
            Programa y publica en todas tus redes desde un solo lugar.
            Empieza con 3 días gratis, sin compromiso.
          </p>
        </div>
        <PricingPlans />
        <PricingComparison />
      </main>
      <SiteFooter />
    </div>
  );
}
